import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import useCountDown from 'src/hooks/useCountDown';

const ProcessingLoading = ({ time = 100, onDone }: { time?: number; onDone: () => void }) => {
  const { timeLeft } = useCountDown(time, true);

  let percent = Math.round(((time - timeLeft) / time) * 100);

  useEffect(() => {
    if (timeLeft == 0) {
      onDone();
    }
  }, [timeLeft]);

  return (
    <Stack justifyContent={'center'}>
      <Typography textAlign={'center'} mb={1} variant="h5">
        Processing Your Products
      </Typography>
      <Typography textAlign={'center'} mb={5} color={'text.secondary'} variant="body2">
        Hold tight! We're analyzing your file for HS Codes.
      </Typography>

      <Box sx={{ position: 'relative', display: 'inline-flex' }} justifyContent="center">
        <CircularProgress thickness={10} size={160} value={percent} variant="determinate" color="secondary" />
        <Box
          sx={{
            inset: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" sx={{ color: 'secondary.main' }}>
            {percent}%
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

export default ProcessingLoading;
